import { defineStore } from "pinia";
import client from "@/api/client";

export const useCartStore = defineStore("cart", {
  state: () => ({
    shoppingCart: null,
    shoppingCartLoading: false,
    cartError: null,
  }),

  getters: {
    shoppingCartItems: (state) => {
      if (state.shoppingCart && state.shoppingCart.length > 0) {
        return state.shoppingCart;
      }

      return [];
    },

    shoppingCartCount: (state) => {
      if (state.shoppingCart) {
        var itemCount = 0;
        state.shoppingCart.forEach((c) => {
          c.Items.forEach((i) => {
            itemCount += i.ArticleCount;
          });
        });
        return itemCount;
      }

      return "";
    },
  },

  actions: {
    startUpdating() {
      this.shoppingCartLoading = true;
      this.cartError = null;
    },

    stopUpdating() {
      this.shoppingCartLoading = false;
    },

    setCartError(error) {
      this.cartError = error;
    },

    setCart(cart) {
      this.shoppingCart = cart;
      this.shoppingCartLoading = false;
    },

    loadShoppingCart() {
      this.startUpdating();
      return client()
        .get("/api2/customer/shoppingcart")
        .then((response) => {
          this.setCart(response.data);
        })
        .catch((error) => this.setCartError(error))
        .finally(() => this.stopUpdating());
    },

    refreshShoppingCart() {
      return client()
        .get("/api2/customer/shoppingcart")
        .then((response) => {
          this.setCart(response.data);
        });
    },

    addItemToCart(item) {
      this.startUpdating();
      return client()
        .post("api2/customer/shoppingcart", item)
        .then(() => {
          this.loadShoppingCart();
        });
    },
  },
});